import axios from 'axios';

export const defaultState = {
  idents: [],
  userIdents: [],
  totalIdents: 0,
  providers: [],
};

export const mutations = {
  SET_IDENT_DATA(identState, { data, meta }) {
    identState.idents = data;
    if (meta && meta.pagination) {
      identState.totalIdents = meta.pagination.total;
    } else {
      identState.totalIdents = 0;
    }
  },
  SET_IDENT_PROVIDERS(identState, data) {
    identState.providers = data;
  },
};

export const getters = {
  getIdents: identState => identState.idents,
};

export const actions = {

  fetchIdentUsers(context, query) {
    return axios.get(
      `${window.BASE_API.ONBOARDING_USERS}/admin/user/${query}`,
    ).then((response) => {
      // parse UserService data to match the legacy backend search output
      response.data = [
        {
          id: response.data.userMetaData.user_id,
          first_name: response.data.userMetaData.data.naturalUser.firstName,
          last_name: response.data.userMetaData.data.naturalUser.lastName,
          email: response.data.congnitoUserData.email,
        },
      ];

      return response.data;
    }).catch(error => Promise.reject(error));
  },

  fetchIdentProviders({ commit, state }) {
    if (state.providers.length > 1) {
      return Promise.resolve(state.providers);
    }

    return axios.get(`${window.BASE_API.IDENT}/providers`)
      .then(({ data }) => {
        // sort by id so that IDNow gets in first options
        data.sort((a, b) => ((a.id > b.id) ? -1 : 1));

        commit('SET_IDENT_PROVIDERS', data);

        return data;
      })
      .catch(error => Promise.reject(error));
  },

  fetchUserIdentificationFiles(context, { id, identType }) {
    return axios.get(`${window.BASE_API.IDENT}/users/${id}/files/${identType}`)
      .then(data => data)
      .catch(error => Promise.reject(error));
  },

  fetchUserDetails({ dispatch }, id) {
    return axios.get(`${window.BASE_API.IDENT}/users/${id}`)
      .then(({ data }) => data.data)
      .then(identData => dispatch('getOnboardingUserById', id)
        .then((data) => {
          const { naturalUser } = data.userMetaData.data;

          return {
            identData,
            userData: {
              id: naturalUser.user_id,
              first_name: naturalUser.firstName,
              last_name: naturalUser.lastName,
              phone: naturalUser.phone,
              sex: naturalUser.sex,
              tax_id: naturalUser.taxId,
              email: data.cognitoUserPoolData.UserAttributes.find(obj => obj.Name === 'email').Value,
              street: naturalUser.address.street,
              street_no: naturalUser.address.streetNo,
              marital_status: naturalUser.address.maritalStatus,
              postal_code: naturalUser.address.postalCode,
              city: naturalUser.address.city,
              country: naturalUser.address.country,
              country_of_birth: naturalUser.birth.country_of_birth,
              pass: naturalUser.legitimationDocument.number,
              pass_authority: naturalUser.legitimationDocument.authority,
              pass_country_of_issue: naturalUser.legitimationDocument.countryOfIssue,
              pass_created_at: naturalUser.legitimationDocument.createdAt,
              pass_expires_at: naturalUser.legitimationDocument.expiresAt,
            } };
        })
        .catch(error => Promise.reject(error)))
      .catch(error => Promise.reject(error));
  },

  fetchIdents({ commit }, query) {
    return axios.get(`${window.BASE_API.IDENT}/idents?${new URLSearchParams(query).toString()}&include=cases`)
      .then(({ data }) => {
        commit('SET_IDENT_DATA', data);

        return data;
      })
      .catch((error) => {
        commit('SET_IDENT_DATA', { data: [] });
        Promise.reject(error);
      });
  },

  createExternalIdent(context, data) {
    const env = localStorage.getItem('Exporo.API.env');
    const postData = { ...data };
    if (env !== 'prod') {
      postData.firstName = 'X-AUTOTEST-HAPPYPATH';
    }

    return axios.post(`${window.BASE_API.IDENT}/users/${data.userId}/idents?forceCreate=true`, postData)
      .then(resp => resp.data);
  },

  createExporoIdent({ dispatch }, data) {
    const caseId = Math.floor(Date.now() / 1000);
    const fileData = {
      fileName: caseId,
      base64String: data.file.content,
      userId: data.userId,
    };

    delete data.file;

    return dispatch('uploadIdentFile', fileData)
      .then(() => {
        data.file = fileData.fileName;
        data.identCaseId = caseId.toString();

        return axios.post(`${window.BASE_API.IDENT}/users/${data.userId}/idents/exporo`, data)
          .then(resp => resp)
          .catch(error => Promise.reject(error));
      })
      .catch(error => Promise.reject(error.response.data.error));
  },

  uploadIdentFile(context, data) {
    return axios.post(`${window.BASE_API.IDENT_S3}/uploadExporoIdentPdfToS3`, data)
      .then(resp => resp)
      .catch(error => Promise.reject(error));
  },

  updateIdentCase(context, data) {
    return axios.post(`${window.BASE_API.IDENT}/users/${data.userId}/idents/${data.identId}/cases/${data.identCaseIdentifier}/update`, data)
      .then(resp => resp)
      .catch(error => Promise.reject(error));
  },

  importIdent(context, data) {
    return axios.post(`${window.BASE_API.IDENT}/users/${data.userId}/idents/${data.provider}/cases/${data.identCaseIdentifier}/import`, data)
      .then(resp => resp)
      .catch(error => Promise.reject(error));
  },

  validateIdent(context, data) {
    return axios.get(`${window.BASE_API.IDENT}/users/${data.userId}/idents/${data.provider}/cases/${data.identCaseIdentifier}/validate`)
      .then(resp => resp)
      .catch(error => Promise.reject(error));
  },

  expireIdentResult(context, userId) {
    return axios.put(`${window.BASE_API.IDENT}/users/${userId}/idents/expire`)
      .then(resp => resp)
      .catch(error => Promise.reject(error));
  },
};

const identStore = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default identStore;



// WEBPACK FOOTER //
// ./src/store/ident/identStore.js